import React from 'react';
export function Hero() {
  return <div className="w-full py-6 md:py-10" data-id="element-344">
      <div className="max-w-3xl mx-auto text-center mb-6" data-id="element-345">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight" data-id="element-346">
          Your <span className="text-red-600" data-id="element-347">Anxiety</span>,{' '}
          <span className="text-red-600" data-id="element-348">Fatigue</span> &{' '}
          <span className="text-red-600" data-id="element-349">Burnout</span> Are Not All in Your Head
          — They Live in Your Nervous System.
        </h1>
        <h2 className="text-2xl md:text-3xl text-gray-700 mb-8 leading-relaxed" data-id="element-350">
          Discover the gentle somatic practice that's helped 30,000 women stop
          the spirals, calm anxiety, and feel safe in their body again — even
          when meds & therapy didn't work.
        </h2>
        <div className="w-full my-6" data-id="element-351">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/x3Bnjj4DTzSCCNWPm5jrLr/488007648_973055568144647_6503679057397182315_n_%281%29.jpg" alt="Vagus nerve diagram showing connection to anxiety and sleep issues" className="w-full max-w-2xl mx-auto h-auto object-contain rounded-lg shadow-md" data-id="element-352" />
        </div>
        <div className="flex flex-col md:flex-row items-center gap-6 bg-gray-50 p-6 rounded-lg shadow-sm mb-8" data-id="element-353">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/j5zTyzAgttUCqoETGdVR5z/a72d7f-b65f-f3f-db31-1bd8fccf7dda_b5678e5b-b47a-449f-a3a7-7890b1473025_%282%29.webp" alt="Dr. Kim DiRé headshot" className="w-32 h-32 rounded-full object-cover shadow-md" data-id="element-354" />
          <p className="text-gray-700 text-left text-xl font-medium" data-id="element-355">
            <span className="font-semibold" data-id="element-356">Dr. Kim DiRé</span> is a Doctor of
            Behavioral Health and trauma therapist with 20+ years of experience
            helping thousands heal chronic stress, trauma, and nervous system
            dysregulation through somatic therapy.
          </p>
        </div>
        <div className="text-left mt-6" data-id="element-357">
          <p className="text-2xl text-gray-700 mb-5 font-medium" data-id="element-358">
            Dear friend,
          </p>
          <p className="text-xl text-gray-700 mb-5 font-medium" data-id="element-359">
            If you've ever felt your heart flutter… A strange twinge in your
            chest… Or a tightness in your throat that made your stomach drop…
          </p>
          <p className="text-xl text-gray-700 mb-5 font-medium" data-id="element-360">
            And in that moment, your brain whispered: "Something's wrong…"
          </p>
          <p className="text-xl text-gray-700 mb-5 font-medium" data-id="element-361">
            You're not alone.
          </p>
        </div>
      </div>
    </div>;
}